import React from "react";
import { Phone, MessageCircle, Siren } from "lucide-react";
import { PHONES, WHATSAPP_URL } from "@/constants/content";

export default function EmergencyBanner() {
  return (
    <section className="py-14 md:py-16 relative overflow-hidden" style={{ background: 'linear-gradient(120deg, #EF4444 0%, #DC2626 60%, #B91C1C 100%)' }} data-testid="emergency-banner">
      <div className="absolute inset-0 opacity-15" style={{ backgroundImage: 'radial-gradient(circle at 15% 30%, white, transparent 40%), radial-gradient(circle at 85% 70%, white, transparent 35%)' }} />
      <div className="container-page relative">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-white">
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center pulse-ring">
              <Siren className="h-7 w-7" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-white/85">24×7 Available</div>
              <h3 className="font-display font-bold text-2xl md:text-3xl lg:text-4xl leading-tight">
                Need Urgent Home Healthcare?
              </h3>
              <div className="text-sm text-white/90 mt-1">
                Our emergency team deploys within 2–3 hours across Delhi NCR.
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href={`tel:${PHONES[0]}`}
              className="inline-flex items-center gap-2 rounded-full bg-white text-red-700 px-6 py-3.5 font-bold text-sm shadow-xl hover:-translate-y-0.5 transition-transform"
              data-testid="emergency-call-btn"
            >
              <Phone className="h-4 w-4" /> Call Now · {PHONES[0]}
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] text-white px-6 py-3.5 font-bold text-sm shadow-xl"
              data-testid="emergency-whatsapp-btn"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
